/**
 * Подписи фильтров используются как placeholder внутри полей:
 * завершающее двоеточие и лишние пробелы при этом не нужны.
 *
 * Пример: «Лечащий врач:» → «Лечащий врач».
 */
export const asPlaceholder = (label) =>
    String(label ?? "")
        .replace(/\s*:\s*$/, "")
        .trim();

export default asPlaceholder;
